import Currency from '../../../utils/currency';

export default {
    nav: {
        daily: "Daily",
        weekly: "Weekly"
    },
    daily: {
        title: "Daily bonus",
        online: "45 min online",
        fishing: "total fishing bets",
        slots: "total slots bets"
    },
    weekly: {
        title: "Weekly bonus",
        online: "250 min online",
        fishing: "total fishing bets",
        slots: "total slots bets"
    },
    get: ({amount, currency}) => `GET ${Currency(amount, currency)}`,
    claimed: `CLAIMED`,
    progress: "Progress",
    claim: ({amount}) => `GET $${amount}`,
    amount: ({amount}) => `$${amount}`,
    users: ({count}) => `${count}`
}